// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Form Section Styling - matching ads-monetization */
.form-section {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.form-section h5 {
  color: #343a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
  font-weight: 600;
}

/* Summary Grid Styling */
.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
  width: 100%;
  overflow: hidden;
}

.summary-item {
  text-align: center;
  padding: 15px 10px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  min-width: 0; /* Prevent flex item overflow */
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100px;
}

.summary-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 10px rgba(0, 123, 255, 0.1);
  transform: translateY(-2px);
}

.summary-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-value {
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 0;
}

/* Theme Colors matching ads-monetization */
.theme-color-blue {
  color: #007bff !important;
}

.theme-color-green {
  color: #28a745 !important;
}

.theme-color-primary {
  color: #6f42c1 !important;
}

.theme-color-success {
  color: #20c997 !important;
}

.theme-bg-light {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
}

/* Status Indicator Styling */
.status-indicator {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.status-indicator.enabled {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.status-indicator.disabled {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.status-icon {
  margin-right: 15px;
  font-size: 1.5rem;
}

/* Form Input Styling */
.profile-form-control {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  width: 100%;
}

.profile-form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: none;
}

.profile-form-control:disabled {
  background-color: #f8f9fa;
  color: #6c757d;
}

/* Alert Styling */
.validation-alert {
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  border: none;
  font-weight: 500;
}

.validation-alert.success {
  background-color: #d4edda;
  color: #155724;
  border-left: 4px solid #28a745;
}

.validation-alert.info {
  background-color: #d1ecf1;
  color: #0c5460;
  border-left: 4px solid #17a2b8;
}

/* Button Styling */
.profile-btn-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  border-radius: 6px;
  font-weight: 500;
  padding: 10px 20px;
  transition: all 0.3s ease;
  color: white;
}

.profile-btn-primary:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.profile-btn-secondary {
  border: 1px solid #6c757d;
  color: #6c757d;
  background: transparent;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 10px 20px;
}

.profile-btn-secondary:hover {
  background-color: #6c757d;
  color: white;
  transform: translateY(-1px);
}

/* Compact header button styling (desktop-first) */
.profile-btn-primary.btn-compact {
  padding: 6px 12px;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

/* Ensure compact stays auto width on desktop */
@media (min-width: 992px) {
  .profile-btn-primary.btn-compact {
    width: auto !important;
  }
}

/* Progress Bar Styling */
.profile-progress {
  height: 10px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #e9ecef;
}

.profile-progress-bar {
  background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);
  border-radius: 10px;
  transition: width 0.6s ease;
  height: 100%;
}

/* Usage Statistics Cards */
.usage-stat-box {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;
  text-align: center;
  transition: all 0.3s ease;
}

.usage-stat-box:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.usage-stat-number {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.usage-stat-number.blue {
  color: #007bff;
}

.usage-stat-number.green {
  color: #28a745;
}

.usage-stat-number.purple {
  color: #6f42c1;
}

.usage-stat-number.teal {
  color: #20c997;
}

.usage-stat-label {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Profile Header Styling */
.profile-header-container {
  padding: 8px;
  margin-bottom: 16px;
  position: relative;
}


.profile-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 8px;
}

.profile-subtitle {
  color: #6c757d;
  font-size: 1rem;
  margin-bottom: 0;
}

/* Mobile-specific sections */
.mobile-form-section {
  position: relative;
}

.mobile-subscription-section {
  position: relative;
}

/* Mobile navigation helpers */
.mobile-section-divider {
  border-top: 2px solid #e9ecef;
  margin: 20px 0;
  display: none;
}

/* Scrollable content for small screens */
@media (max-width: 575px) {
  .summary-grid {
    max-height: none;
    overflow-x: auto;
  }
  
  .mobile-section-divider {
    display: block;
  }
  
  .form-section {
    position: relative;
    overflow: hidden;
  }
  
  /* Ensure touch-friendly interactions */
  .summary-item,
  .usage-stat-box {
    -webkit-tap-highlight-color: rgba(0, 123, 255, 0.1);
    tap-highlight-color: rgba(0, 123, 255, 0.1);
  }
}

/* Responsive Design */

/* Handle browser zoom levels and high resolution displays */
@media (min-width: 1200px) {
  .form-section {
    padding: 20px;
  }
  
  .summary-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    max-width: 100%;
  }
  
  .summary-item {
    padding: 18px 12px;
  }
  
  .usage-stat-number {
    font-size: 2.2rem;
  }
  
  .profile-header-container {
    padding: 12px;
  }
}

/* Zoom-friendly breakpoints */
@media (min-width: 1400px) {
  .summary-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 25px;
  }
  
  .summary-item {
    padding: 20px 15px;
  }
}

/* Large Devices (Desktops 992px and up) - Zoom friendly */
@media (min-width: 992px) and (max-width: 1199px) {
  .form-section {
    padding: 18px;
  }
  
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
    max-width: 100%;
  }
  
  .summary-item {
    padding: 16px 10px;
    min-height: 110px;
  }
  
  .summary-value {
    font-size: 1.4rem;
    line-height: 1.2;
  }
  
  .usage-stat-number {
    font-size: 1.8rem;
  }
}

/* Handle 125% zoom at desktop resolution */
@media (min-width: 1000px) and (max-width: 1300px) {
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .summary-item {
    padding: 14px 8px;
    min-height: 100px;
  }
  
  .summary-value {
    font-size: 1.2rem;
    line-height: 1.3;
  }
  
  .summary-label {
    font-size: 0.8rem;
  }
}

/* Medium Devices (Tablets 768px and up) - Zoom compatible */
@media (min-width: 768px) and (max-width: 991px) {
  .container-fluid {
    padding-left: 15px;
    padding-right: 15px;
  }
  
  .form-section {
    padding: 16px;
    margin-bottom: 15px;
  }
  
  .summary-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    max-width: 100%;
  }
  
  .summary-item {
    padding: 12px 8px;
    min-height: 95px;
  }
  
  .summary-value {
    font-size: 1.3rem;
    line-height: 1.2;
    word-break: break-word;
  }
  
  .summary-label {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }
  
  .usage-stat-number {
    font-size: 1.6rem;
  }
  
  .usage-stat-box {
    padding: 15px;
  }
  
  .profile-header-container {
    padding: 12px 10px;
  }
  
  .profile-title {
    font-size: 1.4rem;
  }
  
  /* Stack form columns on tablets */
  .col-lg-6 {
    margin-bottom: 20px;
  }
}

/* Small Devices (Landscape Phones 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .container-fluid {
    padding-left: 10px;
    padding-right: 10px;
  }
  
  .form-section {
    padding: 14px;
    margin-bottom: 15px;
    border-radius: 6px;
  }
  
  .form-section h5 {
    font-size: 1.1rem;
    margin-bottom: 15px;
    padding-bottom: 8px;
  }
  
  .summary-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .summary-item {
    padding: 12px;
  }
  
  .summary-label {
    font-size: 0.8rem;
    margin-bottom: 6px;
  }
  
  .summary-value {
    font-size: 1.3rem;
  }
  
  .usage-stat-number {
    font-size: 1.6rem;
  }
  
  .usage-stat-box {
    padding: 15px;
    margin-bottom: 12px;
  }
  
  .usage-stat-label {
    font-size: 0.85rem;
  }
  
  .profile-header-container {
    padding: 12px 8px;
  }
  
  .profile-title {
    font-size: 1.4rem;
  }
  
  .profile-subtitle {
    font-size: 0.9rem;
  }
  
  .status-indicator {
    padding: 12px;
    flex-direction: column;
    text-align: center;
  }
  
  .status-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .validation-alert {
    padding: 12px;
    font-size: 0.9rem;
  }
  
  .profile-progress {
    height: 8px;
  }
  
  /* Button adjustments */
  .profile-btn-primary,
  .profile-btn-secondary {
    padding: 12px 20px;
    font-size: 0.9rem;
    width: 100%;
    margin-bottom: 10px;
  }
  
  /* Header button adjustments */
  .d-flex.justify-content-between {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .d-flex.justify-content-between > div:last-child {
    margin-top: 15px;
    width: 100%;
  }
}

/* Extra Small Devices (Portrait Phones less than 576px) */
@media (max-width: 575px) {
  .container-fluid {
    padding-left: 8px;
    padding-right: 8px;
  }
  
  .form-section {
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 6px;
  }
  
  .form-section h5 {
    font-size: 1rem;
    margin-bottom: 12px;
    padding-bottom: 6px;
  }
  
  .profile-form-control {
    padding: 10px 12px;
    font-size: 0.9rem;
  }
  
  .summary-grid {
    grid-template-columns: 1fr;
    gap: 10px;
    margin-bottom: 15px;
  }
  
  .summary-item {
    padding: 10px;
  }
  
  .summary-label {
    font-size: 0.75rem;
    margin-bottom: 4px;
  }
  
  .summary-value {
    font-size: 1.1rem;
  }
  
  .usage-stat-number {
    font-size: 1.4rem;
  }
  
  .usage-stat-box {
    padding: 12px;
    margin-bottom: 10px;
  }
  
  .usage-stat-label {
    font-size: 0.8rem;
  }
  
  .profile-header-container {
    padding: 10px 8px;
  }
  
  .profile-title {
    font-size: 1.2rem;
    line-height: 1.3;
  }
  
  .profile-subtitle {
    font-size: 0.85rem;
    line-height: 1.4;
  }
  
  .status-indicator {
    padding: 10px;
    flex-direction: column;
    text-align: center;
  }
  
  .status-icon {
    margin-right: 0;
    margin-bottom: 8px;
    font-size: 1.2rem;
  }
  
  .validation-alert {
    padding: 10px;
    font-size: 0.85rem;
    line-height: 1.4;
  }
  
  .profile-progress {
    height: 6px;
  }
  
  /* Button adjustments */
  .profile-btn-primary,
  .profile-btn-secondary {
    padding: 10px 16px;
    font-size: 0.85rem;
    width: 100%;
    margin-bottom: 8px;
  }
  
  /* Header becomes full mobile layout */
  .d-flex.justify-content-between {
    flex-direction: column;
    align-items: stretch;
  }
  
  .d-flex.justify-content-between > div:first-child {
    margin-bottom: 15px;
  }
  
  .d-flex.justify-content-between > div:last-child {
    width: 100%;
  }
  
  /* Form labels */
  .form-label {
    font-size: 0.9rem;
    margin-bottom: 8px;
  }
  
  /* Text areas */
  textarea.profile-form-control {
    min-height: 80px;
  }
  
  /* Small text */
  small {
    font-size: 0.75rem;
    line-height: 1.3;
  }
  
  /* Row spacing */
  .row.g-3 {
    --bs-gutter-x: 0.5rem;
  }
  
  .col-md-6 {
    margin-bottom: 10px;
  }
  
  /* No subscription state */
  .text-center.py-5 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  
  .text-center.py-5 .fa-info-circle {
    font-size: 2rem;
  }
}

/* Landscape Phone Orientation */
@media (max-height: 500px) and (orientation: landscape) {
  .form-section {
    padding: 10px;
    margin-bottom: 10px;
  }
  
  .profile-header-container {
    padding: 8px;
  }
  
  .profile-title {
    font-size: 1.1rem;
  }
  
  .status-indicator {
    padding: 8px;
  }
  
  .usage-stat-box {
    padding: 10px;
  }
  
  .usage-stat-number {
    font-size: 1.2rem;
  }
}

/* High DPI Displays */
@media (min-resolution: 192dpi) {
  .form-section {
    border-width: 0.5px;
  }
  
  .summary-item {
    border-width: 0.5px;
  }
  
  .profile-progress {
    border-radius: 6px;
  }
}

/* Browser Zoom Level Compatibility */
@media (min-width: 900px) {
  .summary-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 12px;
  }
  
  .summary-item {
    padding: 12px 6px;
    min-height: 85px;
  }
  
  .summary-value {
    font-size: 1.1rem;
    line-height: 1.1;
  }
  
  .summary-label {
    font-size: 0.7rem;
    margin-bottom: 3px;
  }
}

/* Specific fix for 125% zoom level */
@media (min-width: 1100px) and (max-width: 1400px) {
  .summary-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  
  .summary-item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: calc(50% - 10px);
    margin-bottom: 12px;
    padding: 10px 6px;
    min-height: 80px;
  }
  
  .summary-value {
    font-size: 1rem;
    line-height: 1.1;
  }
  
  .summary-label {
    font-size: 0.65rem;
    margin-bottom: 2px;
  }
}

/* Touch Device Optimizations */
@media (hover: none) and (pointer: coarse) {
  .profile-btn-primary,
  .profile-btn-secondary {
    min-height: 44px;
    font-size: 1rem;
  }
  
  .profile-form-control {
    min-height: 44px;
    font-size: 1rem;
  }
  
  .summary-item {
    min-height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

/* Very high zoom levels (150%+ zoom) */
@media (max-width: 1200px) {
  .summary-grid {
    display: block;
  }
  
  .summary-item {
    display: block;
    width: 100%;
    margin-bottom: 10px;
    padding: 8px 10px;
    min-height: 60px;
  }
  
  .summary-value {
    font-size: 0.95rem;
    line-height: 1.1;
  }
  
  .summary-label {
    font-size: 0.6rem;
    margin-bottom: 1px;
  }
}

/* Extreme zoom levels (200%+ zoom) */
@media (max-width: 800px) {
  .summary-item {
    padding: 6px 8px;
    min-height: 50px;
  }
  
  .summary-value {
    font-size: 0.85rem;
  }
  
  .summary-label {
    font-size: 0.55rem;
  }
  
  .form-section {
    padding: 15px;
  }
}

/* Print Styles */
@media print {
  .profile-btn-primary,
  .profile-btn-secondary {
    display: none;
  }
  
  .form-section {
    box-shadow: none;
    border: 1px solid #000;
    page-break-inside: avoid;
  }
  
  .container-fluid {
    max-width: 100%;
  }
  
  .summary-grid {
    display: block;
  }
  
  .summary-item {
    display: block;
    width: 100%;
    margin-bottom: 10px;
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/ProfileMonetization.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY,EAAE,+BAA+B;EAC7C,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,cAAc;EACd,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,uCAAuC;EACvC;;IAEE,mDAAmD;IACnD,2CAA2C;EAC7C;AACF;;AAEA,sBAAsB;;AAEtB,4DAA4D;AAC5D;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,mBAAmB;EACrB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA,uBAAuB;EACvB;;IAEE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA,uBAAuB;EACvB;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA,gBAAgB;EAChB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,gBAAgB;EAClB;;EAEA,eAAe;EACf;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,gBAAgB;EAChB;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,wBAAwB;EAC1B;AACF","sourcesContent":["/* Form Section Styling - matching ads-monetization */\n.form-section {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  margin-bottom: 20px;\n  border: 1px solid #e9ecef;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.form-section h5 {\n  color: #343a40;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e9ecef;\n  font-weight: 600;\n}\n\n/* Summary Grid Styling */\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 15px;\n  margin-bottom: 25px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.summary-item {\n  text-align: center;\n  padding: 15px 10px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  border: 1px solid #e9ecef;\n  transition: all 0.3s ease;\n  min-width: 0; /* Prevent flex item overflow */\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 100px;\n}\n\n.summary-item:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 10px rgba(0, 123, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n.summary-label {\n  font-size: 0.875rem;\n  color: #6c757d;\n  font-weight: 500;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-value {\n  font-size: 1.75rem;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n/* Theme Colors matching ads-monetization */\n.theme-color-blue {\n  color: #007bff !important;\n}\n\n.theme-color-green {\n  color: #28a745 !important;\n}\n\n.theme-color-primary {\n  color: #6f42c1 !important;\n}\n\n.theme-color-success {\n  color: #20c997 !important;\n}\n\n.theme-bg-light {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;\n}\n\n/* Status Indicator Styling */\n.status-indicator {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  transition: all 0.3s ease;\n}\n\n.status-indicator.enabled {\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n  color: #155724;\n}\n\n.status-indicator.disabled {\n  background-color: #fff3cd;\n  border-color: #ffeaa7;\n  color: #856404;\n}\n\n.status-icon {\n  margin-right: 15px;\n  font-size: 1.5rem;\n}\n\n/* Form Input Styling */\n.profile-form-control {\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 12px 16px;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.profile-form-control:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n  outline: none;\n}\n\n.profile-form-control:disabled {\n  background-color: #f8f9fa;\n  color: #6c757d;\n}\n\n/* Alert Styling */\n.validation-alert {\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 20px;\n  border: none;\n  font-weight: 500;\n}\n\n.validation-alert.success {\n  background-color: #d4edda;\n  color: #155724;\n  border-left: 4px solid #28a745;\n}\n\n.validation-alert.info {\n  background-color: #d1ecf1;\n  color: #0c5460;\n  border-left: 4px solid #17a2b8;\n}\n\n/* Button Styling */\n.profile-btn-primary {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  padding: 10px 20px;\n  transition: all 0.3s ease;\n  color: white;\n}\n\n.profile-btn-primary:hover {\n  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n.profile-btn-secondary {\n  border: 1px solid #6c757d;\n  color: #6c757d;\n  background: transparent;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  padding: 10px 20px;\n}\n\n.profile-btn-secondary:hover {\n  background-color: #6c757d;\n  color: white;\n  transform: translateY(-1px);\n}\n\n/* Compact header button styling (desktop-first) */\n.profile-btn-primary.btn-compact {\n  padding: 6px 12px;\n  font-size: 0.85rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n/* Ensure compact stays auto width on desktop */\n@media (min-width: 992px) {\n  .profile-btn-primary.btn-compact {\n    width: auto !important;\n  }\n}\n\n/* Progress Bar Styling */\n.profile-progress {\n  height: 10px;\n  border-radius: 10px;\n  overflow: hidden;\n  background-color: #e9ecef;\n}\n\n.profile-progress-bar {\n  background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);\n  border-radius: 10px;\n  transition: width 0.6s ease;\n  height: 100%;\n}\n\n/* Usage Statistics Cards */\n.usage-stat-box {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 15px;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.usage-stat-box:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.usage-stat-number {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.usage-stat-number.blue {\n  color: #007bff;\n}\n\n.usage-stat-number.green {\n  color: #28a745;\n}\n\n.usage-stat-number.purple {\n  color: #6f42c1;\n}\n\n.usage-stat-number.teal {\n  color: #20c997;\n}\n\n.usage-stat-label {\n  font-size: 0.9rem;\n  color: #6c757d;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Profile Header Styling */\n.profile-header-container {\n  padding: 8px;\n  margin-bottom: 16px;\n  position: relative;\n}\n\n\n.profile-title {\n  font-size: 1.75rem;\n  font-weight: 600;\n  color: #343a40;\n  margin-bottom: 8px;\n}\n\n.profile-subtitle {\n  color: #6c757d;\n  font-size: 1rem;\n  margin-bottom: 0;\n}\n\n/* Mobile-specific sections */\n.mobile-form-section {\n  position: relative;\n}\n\n.mobile-subscription-section {\n  position: relative;\n}\n\n/* Mobile navigation helpers */\n.mobile-section-divider {\n  border-top: 2px solid #e9ecef;\n  margin: 20px 0;\n  display: none;\n}\n\n/* Scrollable content for small screens */\n@media (max-width: 575px) {\n  .summary-grid {\n    max-height: none;\n    overflow-x: auto;\n  }\n  \n  .mobile-section-divider {\n    display: block;\n  }\n  \n  .form-section {\n    position: relative;\n    overflow: hidden;\n  }\n  \n  /* Ensure touch-friendly interactions */\n  .summary-item,\n  .usage-stat-box {\n    -webkit-tap-highlight-color: rgba(0, 123, 255, 0.1);\n    tap-highlight-color: rgba(0, 123, 255, 0.1);\n  }\n}\n\n/* Responsive Design */\n\n/* Handle browser zoom levels and high resolution displays */\n@media (min-width: 1200px) {\n  .form-section {\n    padding: 20px;\n  }\n  \n  .summary-grid {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    max-width: 100%;\n  }\n  \n  .summary-item {\n    padding: 18px 12px;\n  }\n  \n  .usage-stat-number {\n    font-size: 2.2rem;\n  }\n  \n  .profile-header-container {\n    padding: 12px;\n  }\n}\n\n/* Zoom-friendly breakpoints */\n@media (min-width: 1400px) {\n  .summary-grid {\n    grid-template-columns: repeat(4, 1fr);\n    gap: 25px;\n  }\n  \n  .summary-item {\n    padding: 20px 15px;\n  }\n}\n\n/* Large Devices (Desktops 992px and up) - Zoom friendly */\n@media (min-width: 992px) and (max-width: 1199px) {\n  .form-section {\n    padding: 18px;\n  }\n  \n  .summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 18px;\n    max-width: 100%;\n  }\n  \n  .summary-item {\n    padding: 16px 10px;\n    min-height: 110px;\n  }\n  \n  .summary-value {\n    font-size: 1.4rem;\n    line-height: 1.2;\n  }\n  \n  .usage-stat-number {\n    font-size: 1.8rem;\n  }\n}\n\n/* Handle 125% zoom at desktop resolution */\n@media (min-width: 1000px) and (max-width: 1300px) {\n  .summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n  \n  .summary-item {\n    padding: 14px 8px;\n    min-height: 100px;\n  }\n  \n  .summary-value {\n    font-size: 1.2rem;\n    line-height: 1.3;\n  }\n  \n  .summary-label {\n    font-size: 0.8rem;\n  }\n}\n\n/* Medium Devices (Tablets 768px and up) - Zoom compatible */\n@media (min-width: 768px) and (max-width: 991px) {\n  .container-fluid {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  \n  .form-section {\n    padding: 16px;\n    margin-bottom: 15px;\n  }\n  \n  .summary-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n    max-width: 100%;\n  }\n  \n  .summary-item {\n    padding: 12px 8px;\n    min-height: 95px;\n  }\n  \n  .summary-value {\n    font-size: 1.3rem;\n    line-height: 1.2;\n    word-break: break-word;\n  }\n  \n  .summary-label {\n    font-size: 0.75rem;\n    margin-bottom: 4px;\n  }\n  \n  .usage-stat-number {\n    font-size: 1.6rem;\n  }\n  \n  .usage-stat-box {\n    padding: 15px;\n  }\n  \n  .profile-header-container {\n    padding: 12px 10px;\n  }\n  \n  .profile-title {\n    font-size: 1.4rem;\n  }\n  \n  /* Stack form columns on tablets */\n  .col-lg-6 {\n    margin-bottom: 20px;\n  }\n}\n\n/* Small Devices (Landscape Phones 576px and up) */\n@media (min-width: 576px) and (max-width: 767px) {\n  .container-fluid {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  \n  .form-section {\n    padding: 14px;\n    margin-bottom: 15px;\n    border-radius: 6px;\n  }\n  \n  .form-section h5 {\n    font-size: 1.1rem;\n    margin-bottom: 15px;\n    padding-bottom: 8px;\n  }\n  \n  .summary-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    margin-bottom: 20px;\n  }\n  \n  .summary-item {\n    padding: 12px;\n  }\n  \n  .summary-label {\n    font-size: 0.8rem;\n    margin-bottom: 6px;\n  }\n  \n  .summary-value {\n    font-size: 1.3rem;\n  }\n  \n  .usage-stat-number {\n    font-size: 1.6rem;\n  }\n  \n  .usage-stat-box {\n    padding: 15px;\n    margin-bottom: 12px;\n  }\n  \n  .usage-stat-label {\n    font-size: 0.85rem;\n  }\n  \n  .profile-header-container {\n    padding: 12px 8px;\n  }\n  \n  .profile-title {\n    font-size: 1.4rem;\n  }\n  \n  .profile-subtitle {\n    font-size: 0.9rem;\n  }\n  \n  .status-indicator {\n    padding: 12px;\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .status-icon {\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n  \n  .validation-alert {\n    padding: 12px;\n    font-size: 0.9rem;\n  }\n  \n  .profile-progress {\n    height: 8px;\n  }\n  \n  /* Button adjustments */\n  .profile-btn-primary,\n  .profile-btn-secondary {\n    padding: 12px 20px;\n    font-size: 0.9rem;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n  \n  /* Header button adjustments */\n  .d-flex.justify-content-between {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .d-flex.justify-content-between > div:last-child {\n    margin-top: 15px;\n    width: 100%;\n  }\n}\n\n/* Extra Small Devices (Portrait Phones less than 576px) */\n@media (max-width: 575px) {\n  .container-fluid {\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n  \n  .form-section {\n    padding: 12px;\n    margin-bottom: 12px;\n    border-radius: 6px;\n  }\n  \n  .form-section h5 {\n    font-size: 1rem;\n    margin-bottom: 12px;\n    padding-bottom: 6px;\n  }\n  \n  .profile-form-control {\n    padding: 10px 12px;\n    font-size: 0.9rem;\n  }\n  \n  .summary-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n    margin-bottom: 15px;\n  }\n  \n  .summary-item {\n    padding: 10px;\n  }\n  \n  .summary-label {\n    font-size: 0.75rem;\n    margin-bottom: 4px;\n  }\n  \n  .summary-value {\n    font-size: 1.1rem;\n  }\n  \n  .usage-stat-number {\n    font-size: 1.4rem;\n  }\n  \n  .usage-stat-box {\n    padding: 12px;\n    margin-bottom: 10px;\n  }\n  \n  .usage-stat-label {\n    font-size: 0.8rem;\n  }\n  \n  .profile-header-container {\n    padding: 10px 8px;\n  }\n  \n  .profile-title {\n    font-size: 1.2rem;\n    line-height: 1.3;\n  }\n  \n  .profile-subtitle {\n    font-size: 0.85rem;\n    line-height: 1.4;\n  }\n  \n  .status-indicator {\n    padding: 10px;\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .status-icon {\n    margin-right: 0;\n    margin-bottom: 8px;\n    font-size: 1.2rem;\n  }\n  \n  .validation-alert {\n    padding: 10px;\n    font-size: 0.85rem;\n    line-height: 1.4;\n  }\n  \n  .profile-progress {\n    height: 6px;\n  }\n  \n  /* Button adjustments */\n  .profile-btn-primary,\n  .profile-btn-secondary {\n    padding: 10px 16px;\n    font-size: 0.85rem;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  \n  /* Header becomes full mobile layout */\n  .d-flex.justify-content-between {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .d-flex.justify-content-between > div:first-child {\n    margin-bottom: 15px;\n  }\n  \n  .d-flex.justify-content-between > div:last-child {\n    width: 100%;\n  }\n  \n  /* Form labels */\n  .form-label {\n    font-size: 0.9rem;\n    margin-bottom: 8px;\n  }\n  \n  /* Text areas */\n  textarea.profile-form-control {\n    min-height: 80px;\n  }\n  \n  /* Small text */\n  small {\n    font-size: 0.75rem;\n    line-height: 1.3;\n  }\n  \n  /* Row spacing */\n  .row.g-3 {\n    --bs-gutter-x: 0.5rem;\n  }\n  \n  .col-md-6 {\n    margin-bottom: 10px;\n  }\n  \n  /* No subscription state */\n  .text-center.py-5 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  \n  .text-center.py-5 .fa-info-circle {\n    font-size: 2rem;\n  }\n}\n\n/* Landscape Phone Orientation */\n@media (max-height: 500px) and (orientation: landscape) {\n  .form-section {\n    padding: 10px;\n    margin-bottom: 10px;\n  }\n  \n  .profile-header-container {\n    padding: 8px;\n  }\n  \n  .profile-title {\n    font-size: 1.1rem;\n  }\n  \n  .status-indicator {\n    padding: 8px;\n  }\n  \n  .usage-stat-box {\n    padding: 10px;\n  }\n  \n  .usage-stat-number {\n    font-size: 1.2rem;\n  }\n}\n\n/* High DPI Displays */\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {\n  .form-section {\n    border-width: 0.5px;\n  }\n  \n  .summary-item {\n    border-width: 0.5px;\n  }\n  \n  .profile-progress {\n    border-radius: 6px;\n  }\n}\n\n/* Browser Zoom Level Compatibility */\n@media (min-width: 900px) {\n  .summary-grid {\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 12px;\n  }\n  \n  .summary-item {\n    padding: 12px 6px;\n    min-height: 85px;\n  }\n  \n  .summary-value {\n    font-size: 1.1rem;\n    line-height: 1.1;\n  }\n  \n  .summary-label {\n    font-size: 0.7rem;\n    margin-bottom: 3px;\n  }\n}\n\n/* Specific fix for 125% zoom level */\n@media (min-width: 1100px) and (max-width: 1400px) {\n  .summary-grid {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n  }\n  \n  .summary-item {\n    flex: 1 1 calc(50% - 10px);\n    max-width: calc(50% - 10px);\n    margin-bottom: 12px;\n    padding: 10px 6px;\n    min-height: 80px;\n  }\n  \n  .summary-value {\n    font-size: 1rem;\n    line-height: 1.1;\n  }\n  \n  .summary-label {\n    font-size: 0.65rem;\n    margin-bottom: 2px;\n  }\n}\n\n/* Touch Device Optimizations */\n@media (hover: none) and (pointer: coarse) {\n  .profile-btn-primary,\n  .profile-btn-secondary {\n    min-height: 44px;\n    font-size: 1rem;\n  }\n  \n  .profile-form-control {\n    min-height: 44px;\n    font-size: 1rem;\n  }\n  \n  .summary-item {\n    min-height: 60px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n\n/* Very high zoom levels (150%+ zoom) */\n@media (max-width: 1200px) {\n  .summary-grid {\n    display: block;\n  }\n  \n  .summary-item {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n    padding: 8px 10px;\n    min-height: 60px;\n  }\n  \n  .summary-value {\n    font-size: 0.95rem;\n    line-height: 1.1;\n  }\n  \n  .summary-label {\n    font-size: 0.6rem;\n    margin-bottom: 1px;\n  }\n}\n\n/* Extreme zoom levels (200%+ zoom) */\n@media (max-width: 800px) {\n  .summary-item {\n    padding: 6px 8px;\n    min-height: 50px;\n  }\n  \n  .summary-value {\n    font-size: 0.85rem;\n  }\n  \n  .summary-label {\n    font-size: 0.55rem;\n  }\n  \n  .form-section {\n    padding: 15px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .profile-btn-primary,\n  .profile-btn-secondary {\n    display: none;\n  }\n  \n  .form-section {\n    box-shadow: none;\n    border: 1px solid #000;\n    page-break-inside: avoid;\n  }\n  \n  .container-fluid {\n    max-width: 100%;\n  }\n  \n  .summary-grid {\n    display: block;\n  }\n  \n  .summary-item {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
